module.exports = __webpack_public_path__ + "img/v3.16a6b940.jpg";